// extracted by mini-css-extract-plugin
module.exports =  {"selectButton":"ViewToggle__selectButton--cL","itemLabel":"ViewToggle__itemLabel--ql"};